module.exports = __webpack_public_path__ + "img/_unitedstates.d51fb444.png";